/**
 * ELITE MEGA MENU — House of LEDs
 * Keyboard navigation, hover intent, viewport overflow guard.
 */
(function () {
  'use strict';

  var HOVER_DELAY = 80;
  var CLOSE_DELAY = 120;
  var VIEWPORT_MARGIN = 16;
  var activeMenu = null;
  var hoverTimer = null;
  var closeTimer = null;
  var prefetched = {};

  function init() {
    var items = document.querySelectorAll('.navigation-item.has-sub-menu');

    items.forEach(function (item) {
      var mega = item.querySelector('[data-elite-mega]');
      if (!mega) return;

      // Belt-and-suspenders: force position:relative on the parent <li>
      // in JS as well, in case CSS :has() is unsupported.
      item.style.position = 'relative';

      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        hoverTimer = setTimeout(function () { open(item, mega); }, HOVER_DELAY);
      });

      item.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimer);
        closeTimer = setTimeout(function () { close(item, mega); }, CLOSE_DELAY);
      });

      mega.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      mega.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () { close(item, mega); }, CLOSE_DELAY);
      });

      var trigger = item.querySelector(':scope > a');
      if (trigger) {
        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (mega.getAttribute('data-active') === 'true') {
              close(item, mega);
              trigger.focus();
            } else {
              open(item, mega);
              var first = mega.querySelector('a');
              if (first) first.focus();
            }
          }
          if (e.key === 'Escape') {
            close(item, mega);
            trigger.focus();
          }
        });
      }

      mega.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          close(item, mega);
          if (trigger) trigger.focus();
        }
        if (e.key === 'Tab' && !e.shiftKey) {
          var links = mega.querySelectorAll('a[href]');
          if (links.length && e.target === links[links.length - 1]) {
            close(item, mega);
          }
        }
      });

      // Prefetch on hover
      mega.querySelectorAll('a[href]').forEach(function (link) {
        var t;
        link.addEventListener('mouseenter', function () {
          t = setTimeout(function () { prefetchUrl(link.href); }, 150);
        });
        link.addEventListener('mouseleave', function () { clearTimeout(t); });
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.navigation-item.has-sub-menu')) closeAll();
    });
  }

  function open(item, mega) {
    if (activeMenu && activeMenu !== mega) {
      var prev = activeMenu.closest('.navigation-item');
      if (prev) prev.classList.remove('elite-mega-active');
      activeMenu.setAttribute('data-active', 'false');
      activeMenu.setAttribute('aria-hidden', 'true');
      resetPosition(activeMenu);
      var prevTrigger = prev && prev.querySelector(':scope > a');
      if (prevTrigger) prevTrigger.setAttribute('aria-expanded', 'false');
    }

    // Reset position before measuring
    resetPosition(mega);

    mega.setAttribute('data-active', 'true');
    mega.setAttribute('aria-hidden', 'false');
    item.classList.add('elite-mega-active');
    activeMenu = mega;

    var trigger = item.querySelector(':scope > a');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
      trigger.setAttribute('aria-haspopup', 'true');
    }

    // Viewport overflow guard: if right edge overflows, flip anchor
    requestAnimationFrame(function () {
      var rect = mega.getBoundingClientRect();
      if (rect.right > window.innerWidth - VIEWPORT_MARGIN) {
        mega.style.left = 'auto';
        mega.style.right = '0';
      }
    });
  }

  function close(item, mega) {
    mega.setAttribute('data-active', 'false');
    mega.setAttribute('aria-hidden', 'true');
    item.classList.remove('elite-mega-active');
    resetPosition(mega);
    var trigger = item.querySelector(':scope > a');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (activeMenu === mega) activeMenu = null;
  }

  function resetPosition(mega) {
    mega.style.left = '';
    mega.style.right = '';
  }

  function closeAll() {
    document.querySelectorAll('[data-elite-mega][data-active="true"]').forEach(function (m) {
      var item = m.closest('.navigation-item');
      if (item) close(item, m);
    });
  }

  function prefetchUrl(url) {
    if (!url || prefetched[url] || url.charAt(0) === '#') return;
    var c = navigator.connection || navigator.mozConnection;
    if (c && (c.saveData || /2g/.test(c.effectiveType || ''))) return;
    try {
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = url;
      l.as = 'document';
      document.head.appendChild(l);
      prefetched[url] = true;
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
